import { UnloadingSpecies } from "./unloading-species.model";
import { LookupItem } from "./lookup-item.model";

/**
 * Unloading model
 * Only used for HMS Albacore
 */
export class Unloading {

  unloadingID: string = '';

  unloadingDate!: Date;

  unloadingPort: LookupItem = new LookupItem('', 0);

  species: UnloadingSpecies[] = [];

  constructor() {

  }


  static transformAnonymous(anon: any): Unloading {
    let ul = new Unloading();
    ul.unloadingID = anon.unloadingID;
    ul.unloadingDate = new Date(anon.unloadingDate);
    ul.unloadingPort = LookupItem.transformAnonymous(anon.unloadingPort);
    ul.species = (anon.species as any[]).map(s => UnloadingSpecies.transformAnonymous(s));
    return ul;
  }

}
